import React, { useState, useContext, useEffect } from "react";
import { getQueryParams } from '../../helpers/helpers';
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import api from "../../services/api";
import CustomizedSnackbars from "../../components/alert/Alert";

import { onSignIn } from "../../auth/index";

import AuthContext from "../../auth/context";

import logo from "../../images/perto-logo.png";
import {
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

let text = "";
let tipo = "";

export default function Login({ validarSessao, history, location }) {
  const parametros = getQueryParams(location.search);
  const { atualizarUsuario } = useContext(AuthContext);

  const [CPF, setCPF] = useState("");
  const [senha, setSenha] = useState("");
  const [alerta, setAlerta] = useState(false);
  const [mensagem, setMensagem] = useState({});

  const [values, setValues] = useState({
    amount: "",
    password: "",
    weight: "",
    weightRange: "",
    showPassword: false,
  });

  useEffect(() => {
    if(parametros.timeout === '1') setMensagem({tipo: 'alerta', msg: 'Sua sessão expirou. Refaça o login para restabelecer o acesso.'});
  }, []);

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
    setSenha(event.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!CPF || !senha) {
      text = "Preencha CPF e Senha para acesso";
      tipo = "warning";
      alertMsg();
    } else {
      api
        .post("usuarios/autenticar", { CPF, senha })
        .then((res) => {
          if (res.tokenAcesso) {
            onSignIn(res.tokenAcesso);
            validarSessao(atualizarUsuario);

            if(parametros.goto) history.push(`/app/${parametros.goto}`);

            history.push("/app");
          }
        })
        .catch((e) => alertErroMsg());
    }
  };

  const alertMsg = () => {
    setAlerta(true);
    setTimeout(() => setAlerta(false), 3000);
  };

  const alertErroMsg = () => {
    text = "Login ou senha inválidos";
    tipo = "error";
    setAlerta(true);
    setTimeout(() => setAlerta(false), 3000);
  };

  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        style={{ marginTop: "1%" }}
      >
        <div
          style={{
            width: window.innerWidth < 800 ? "100%" : "450px",
            backgroundColor: "white",
            textAlign: "center",
            borderRadius: '50px'
          }}
        >
          <form onSubmit={handleSubmit}>
            <div style={{ background: "#f7af14", color: "white", padding: 20,  borderRadius: '50px' }}>
              <img src={logo} alt="logo" style={{ width: 200 }} />
              <h4>Painel Administrativo</h4>
            </div>
            <Stack spacing={1} sx={{ width: "100%" }} style={{paddingTop: 15}}>
              {mensagem.msg &&
                <div style={{padding: 10, backgroundColor: mensagem.tipo === 'sucesso' ? 'green' : 'darkorange'}}>
                  <h5>{mensagem.msg}</h5>
                </div>
              }        
              <TextField
                style={{ margin: "20px", background: "#FFFF" }}
                id="CPF"
                label="CPF"
                variant="outlined"
                onChange={(event) => setCPF(event.target.value)}
              />

              <FormControl
                style={{ margin: "20px", background: "#FFFF" }}
                variant="outlined"
              >
                <InputLabel htmlFor="outlined-adornment-password">
                  Password
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  type={values.showPassword ? "text" : "password"}
                  value={values.password}
                  onChange={handleChange("password")}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {values.showPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Password"
                />
              </FormControl>

              <div style={{ paddingLeft: 10, paddingRight: 10, display: 'flex', flexDirection: 'column' }}>
                <Button
                  style={{ color: "white", marginBottom: 30}}
                  color="primary"
                  type="submit"
                  variant="contained"
                  fullWidth
                >
                  Entrar
                </Button>
                <div style={{display: 'flex', justifyContent: 'space-between', paddingBottom: 15}}>
                  <a
                    style={{ color: "black", fontSize: "1.2rem", padding: 10 }}
                    href="/criar-conta"
                  >
                    Criar uma conta
                  </a>
                  <a
                    style={{ color: "black", fontSize: "1.2rem", padding: 10 }}
                    href="/recuperar-senha"
                  >
                    Esqueci minha senha
                  </a>
                </div>
                
              </div>
            </Stack>
            {alerta && (
              <CustomizedSnackbars
                texto={text}
                tipo={tipo}
              ></CustomizedSnackbars>
            )}
          </form>
        </div>
      </Grid>
    </div>
  );
}
